<template>
    <cadastro-simples-form
        endpoint="tipo-requerimento"
        rota-base="/admin/tipo-requerimento"
        titulo-singular="Tipo de Requerimento"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
